var map = {
	"./explanation/scores.png": "3594",
	"./global/score-0.png": "63fa",
	"./global/score-1.png": "c813",
	"./global/score-10.png": "ed6e",
	"./global/score-2.png": "19ef",
	"./global/score-3.png": "b949",
	"./global/score-4.png": "6ea3",
	"./global/score-5.png": "5385",
	"./global/score-6.png": "887f",
	"./global/score-7.png": "db34",
	"./global/score-8.png": "0a7b",
	"./global/score-9.png": "69db",
	"./homonym/score-0.png": "d5c5",
	"./homonym/score-1.png": "2b4c",
	"./homonym/score-10.png": "ea7a",
	"./homonym/score-2.png": "4ec5",
	"./homonym/score-3.png": "c73e",
	"./homonym/score-4.png": "babd",
	"./homonym/score-5.png": "bc34",
	"./homonym/score-6.png": "748b",
	"./homonym/score-7.png": "cdc8",
	"./homonym/score-8.png": "b7bc",
	"./homonym/score-9.png": "defe",
	"./id/score-0.png": "c344",
	"./id/score-1.png": "a79b",
	"./id/score-10.png": "9372",
	"./id/score-2.png": "3042",
	"./id/score-3.png": "5b7b",
	"./id/score-4.png": "6770",
	"./id/score-5.png": "51c8",
	"./id/score-6.png": "3703",
	"./id/score-7.png": "7532",
	"./id/score-8.png": "849f",
	"./id/score-9.png": "1b94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "980a";